var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home_black_48dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_black_48dp"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1 0 23 0 23 22 1 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4.16470588 L18,9.45882353 L18,18.6470588 L15.6,18.6470588 L15.6,11.5882353 L8.4,11.5882353 L8.4,18.6470588 L6,18.6470588 L6,9.45882353 L12,4.16470588 M12,1 L0,11.5882353 L3.6,11.5882353 L3.6,21 L10.8,21 L10.8,13.9411765 L13.2,13.9411765 L13.2,21 L20.4,21 L20.4,11.5882353 L24,11.5882353 L12,1 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5b79b67f7d31311db129b568be88319b.svg";
export { ForwardRef as ReactComponent };